import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';

import Section, {
  SectionHeader, SectionTitle, SectionBody, SectionBodyEmptyContent,
} from 'components/common/Section';
import IconUserCard from 'components/icons/IconUserCard';
import SalesRepresentativeCreateEditDialog from 'components/settings/SalesRepresentativeCreateEditDialog';
import SortableList from 'components/common/SortableList';

import { changePatientResource } from 'redux/modules/patients';

import SalesRepresentativesItem from './SalesRepresentativesItem';
import SalesRepresentativesAddForm from './SalesRepresentativesAddForm';

const styles = theme => ({
  iconPlus: {
    width: 14,
    height: 14,
    marginRight: 10,
  },
  button: {
    marginLeft: 20,
  },
  iconUserCard: {
    width: 20,
    height: 16,
  },
  form: {
    width: '65%',
  },
  desktopOnly: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});

class SalesRepresentatives extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: false,
      loading: false,
    };

    this.onCreateButtonClick = this.onCreateButtonClick.bind(this);
    this.onDialogClose = this.onDialogClose.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onCreateButtonClick() {
    this.setState({ dialogOpen: true });
  }

  onDialogClose() {
    this.setState({ dialogOpen: false });
  }

  onChange(values) {
    const { patient, actions } = this.props;
    this.setState({ loading: true });
    actions.changePatientResource({
      'Record Number': patient['Record Number'],
      'Sales Representative ID': values,
      resolve: () => {
        this.setState({ loading: false });
      },
      reject: () => {
        this.setState({ loading: false });
      },
    });
  }

  render() {
    const { patient, classes } = this.props;
    const { dialogOpen, loading } = this.state;
    return (
      <Section>
        <SectionHeader>
          <SectionTitle>
            Sales <span className={classes.desktopOnly}>Representative</span>
          </SectionTitle>
          <SalesRepresentativesAddForm
            className={classes.form}
            onCreateButtonClick={this.onCreateButtonClick}
            disabled={!patient}
            variant="default"
            onSubmitSuccess={(values) => {
              this.onChange([
                values.ID,
                ...patient['Sales Representative'].map(item => item.ID),
              ]);
            }}
            salesRepresentative={patient['Sales Representative']}
          />
        </SectionHeader>
        <SectionBody padding="none">
          {(!patient || patient['Sales Representative'].length === 0) ? (
            <SectionBodyEmptyContent
              text="There are no sale persons yet"
              icon={(
                <IconUserCard className={classes.iconUserCard} />
              )}
            />
          ) : (
            <SortableList
              id="sortableListSalesRepresentative"
              items={patient['Sales Representative']}
              itemComponent={SalesRepresentativesItem}
              dragDisabled={loading}
              onSortingChange={(values) => {
                this.onChange(values.sortedItems.map(item => item.ID));
              }}
            />
          )}
          <SalesRepresentativeCreateEditDialog
            form="salesRepresentativeCreate"
            open={dialogOpen}
            onClose={this.onDialogClose}
            onSubmitSuccess={(values) => {
              this.onChange([
                values.ID,
                ...patient['Sales Representative'].map(item => item.ID),
              ]);
            }}
          />
        </SectionBody>
      </Section>
    );
  }
}

SalesRepresentatives.propTypes = {
  patient: PropTypes.shape({
    'Record Number': PropTypes.number,
    'Sales Representative': PropTypes.arrayOf(PropTypes.shape({
      ID: PropTypes.number.isRequired,
    })).isRequired,
  }),
  actions: PropTypes.shape({
    changePatientResource: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    iconPlus: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    iconUserCard: PropTypes.string.isRequired,
  }).isRequired,
};

SalesRepresentatives.defaultProps = {
  patient: null,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ changePatientResource }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withStyles(styles)(SalesRepresentatives),
);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/SalesRepresentatives/SalesRepresentatives.js